import React from "react";

const Okay = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77"
      height="77"
      viewBox="0 0 77 77"
      fill="none"
    >
      <path
        d="M38.5 77C59.763 77 77 59.763 77 38.5C77 17.237 59.763 0 38.5 0C17.237 0 0 17.237 0 38.5C0 59.763 17.237 77 38.5 77Z"
        fill="#FBC926"
      />
      <path
        d="M34 72.6984C24.9 72.6984 16.6 69.4984 10 64.2984C17 72.0984 27.2 76.9984 38.5 76.9984C59.8 76.9984 77 59.7984 77 38.4984C77 26.2984 71.3 15.4984 62.5 8.39844C68.7 15.1984 72.5 24.2984 72.5 34.1984C72.5 55.4984 55.2 72.6984 34 72.6984Z"
        fill="#F4BF11"
      />
      <path
        d="M27.4004 33.8992C27.2004 33.8992 27.1004 33.8992 26.9004 33.7992C26.7004 33.7992 26.6004 33.6992 26.4004 33.6992C26.2004 33.5992 26.1004 33.5992 26.0004 33.4992C25.9004 33.3992 25.7004 33.2992 25.6004 33.1992C25.5004 33.0992 25.4004 32.9992 25.3004 32.7992C25.2004 32.6992 25.1004 32.4992 25.1004 32.3992C25.0004 32.1992 25.0004 32.0992 25.0004 31.8992C25.0004 31.6992 24.9004 31.5992 24.9004 31.3992C24.9004 31.1992 24.9004 31.0992 25.0004 30.8992C25.0004 30.6992 25.1004 30.5992 25.1004 30.3992C25.2004 30.1992 25.2004 30.0992 25.3004 29.9992C25.4004 29.8992 25.5004 29.6992 25.6004 29.5992C25.7004 29.4992 25.8004 29.3992 26.0004 29.2992C26.1004 29.1992 26.3004 29.0992 26.4004 29.0992C26.6004 28.9992 26.7004 28.9992 26.9004 28.9992C27.7004 28.7992 28.6004 29.0992 29.2004 29.6992C29.3004 29.7992 29.4004 29.8992 29.5004 30.0992C29.6004 30.1992 29.7004 30.3992 29.7004 30.4992C29.8004 30.6992 29.8004 30.7992 29.8004 30.9992C29.8004 31.1992 29.9004 31.2992 29.9004 31.4992C29.9004 31.6992 29.9004 31.7992 29.8004 31.9992C29.8004 32.1992 29.7004 32.2992 29.7004 32.4992C29.6004 32.6992 29.6004 32.7992 29.5004 32.8992C29.4004 32.9992 29.3004 33.1992 29.2004 33.2992C28.7004 33.5992 28.1004 33.8992 27.4004 33.8992Z"
        fill="#332F2E"
      />
      <path
        d="M49.6 33.9016C48.9 33.9016 48.3 33.6016 47.8 33.1016C47.3 32.7016 47 32.0016 47 31.4016C47 30.8016 47.3 30.1016 47.8 29.6016C48.8 28.6016 50.5 28.6016 51.4 29.6016C51.9 30.1016 52.2 30.7016 52.2 31.4016C52.2 32.1016 51.9 32.7016 51.4 33.2016C50.9 33.6016 50.3 33.9016 49.6 33.9016Z"
        fill="#332F2E"
      />
      <path
        d="M40.7004 48.1H36.2004C35.5004 48.1 34.9004 47.5 34.9004 46.8C34.9004 46.1 35.5004 45.5 36.2004 45.5H40.7004C41.4004 45.5 42.0004 46.1 42.0004 46.8C42.0004 47.6 41.5004 48.1 40.7004 48.1Z"
        fill="#332F2E"
      />
    </svg>
  );
};

export default Okay;
